import React from 'react';

export default function About() {
  return (
    <section className="bg-white rounded-lg shadow-md p-4 sm:p-6 md:p-8 mb-8" aria-label="O půjčovně tumbleru">
      <h2 className="text-2xl sm:text-3xl font-bold text-stone-800 mb-3 sm:mb-4">
        Ahoj! Vítej v Tromluj - půjčovně rotační tromlovačky v Brně
      </h2>

      <div className="flex flex-col md:flex-row gap-4 sm:gap-6">
        <div className="flex-1">
          <p className="text-sm sm:text-base text-stone-600 mb-3 sm:mb-4">
            Máme doma <strong>rotační tromlovačku</strong> (tumbler) a napadlo nás, proč ho nepůjčovat
            lidem, které taky baví <strong>šutry</strong> a <strong>minerály</strong>, rádi by si <strong>vlastní nálezy</strong> naleštili
            ale nechtějí si kvůli tomu kupovat vlastní přístroj. Obvykle to trvá 2-4 týdny, než jsou kameny hotové.
          </p>
          <p className="text-sm sm:text-base text-stone-600 mb-3 sm:mb-4">
            Máme <strong>Lortone rotační tromlovačku (0.8 litru)</strong> - je to solidní <strong>zařízení</strong> ze Států,
            my s ním máme super zkušenosti. Ideální pro <strong>tromlování kamenů</strong>, <strong>leštění minerálů</strong> a všechno kolem <strong>hobby tromlování</strong>.
          </p>
          <p className="text-sm sm:text-base text-stone-600 mb-3 sm:mb-4">
            Nabízíme <strong>půjčení tromlovačky</strong> i službu, kdy kameny vytromlujeme a naleštíme za vás.
            Osobní předání v Brně, rádi poradíme s potřebným materiálem a celým procesem.
          </p>
        </div>

        <div className="md:w-80 flex-shrink-0">
          <img
            src="/tumbler.jpg"
            alt="Lortone rotační tromlovačka - tumbler na půjčení v Brně pro tromlování a leštění minerálů a kamenů"
            title="Rotační tumbler Lortone pro hobby tromlování kamenů"
            className="rounded-lg shadow-lg w-full object-cover"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
}
